import React from 'react';
import '../../FormBuilder.css';

const SubTitleElement = ({ component, isRequired }) => {
  const renderElement = () => {
    return (
      component.elementName === 'subTitle' && (
        <label className='titleTextLbl'>
            {component.fieldName || "Sub Title"}
            <span className='requiredContainer' style={{ color: 'red' }}>{isRequired(component)}</span>
        </label>
      )
    );
  };

  return (
    <div className='renderAllElements'>
      {renderElement()}
    </div>
  );
};

export default SubTitleElement;
